// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserTrialOutputStartdate } from './userTrialOutputStartdate';
import type { UserTrialOutputDurationDays } from './userTrialOutputDurationDays';
import type { UserTrialOutputMessage } from './userTrialOutputMessage';
import type { UserTrialOutputCtaLink } from './userTrialOutputCtaLink';
import type { UserTrialOutputCtaLabel } from './userTrialOutputCtaLabel';

/**
 * Parameters for trial user accounts
 */
export interface UserTrialOutput {
  isTrial?: boolean;
  startdate?: UserTrialOutputStartdate;
  durationDays?: UserTrialOutputDurationDays;
  message?: UserTrialOutputMessage;
  ctaLink?: UserTrialOutputCtaLink;
  ctaLabel?: UserTrialOutputCtaLabel;
  /** Check if trial is active */
  readonly trialActive: boolean;
}
